import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { HTTPService } from 'src/app/services/http.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { DateUtils } from '../utils/DateUtils';
import { ObjectUtil } from '../utils/ObjectUtil';
import { Validacoes } from '../utils/validators/validacao';
import { UserAuthentication } from 'src/app/interfaces/user-authentication';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
    selector: 'change-password-form',
    templateUrl: './change-password-form.component.html',
    styleUrls: ['./change-password-form.component.scss'],
    standalone: false
})
export class ChangePasswordFormComponent implements OnInit{

  sub:Subscription;
  hide = true;
  hideConfirmacao = true;
  senhaGroup:UntypedFormGroup;
  disabled = true;
  oldPassword = null;
  sessionMFA = null;
  userName = null;
  preferEmail = null;
  forcePassword = false;
  needMFA = false;
  saving = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data, public dialogRef:MatDialogRef<any>,
    private us:UserAuthenticationServices, private http:HTTPService,
    private snackBar:SnackbarService,public ThemeService:ThemeService,
    public datepipe: DatePipe) { }

  ngOnInit(): void {
    
    this.oldPassword = this.data.oldPass;
    this.sessionMFA = this.data.sessionMFA;
    this.userName = this.data.userName;
    this.preferEmail = this.data.preferEmail
    this.forcePassword  = this.data.forcePassword;
    this.needMFA = this.data.needMFA != null && this.data.needMFA == "S" ? true : false;

    this.senhaGroup = new UntypedFormGroup({
      password: new UntypedFormControl('', 
      
      Validators.compose([
          Validators.required,
          Validacoes.SamePassword(this.oldPassword),
          Validacoes.patternValidator(/\d/, { hasNumber: true }),
          Validacoes.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
          Validacoes.patternValidator(/[a-z]/, { hasSmallCase: true }),
          Validacoes.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
          Validacoes.patternValidator(/[$&+,:;=?@#|'<>.^*()%!-]/, { hasSpecialCharacter: true }),
          Validators.minLength(12)
        ])
      ),
      confirmacao: new UntypedFormControl('',Validators.compose([Validators.required,Validators.minLength(4)])),
      mfaCode: new UntypedFormControl('', Validators.nullValidator),
   },Validators.compose([Validacoes.SenhasCombinam, Validacoes.SamePassword(this.oldPassword)]));
   

   this.senhaGroup.valueChanges.subscribe(data=>{
      
      if ( this.senhaGroup.valid && !this.senhaGroup.pristine && this.confirmacao.valid && !this.confirmacao.pristine){
        this.disabled = false;
      }
   });
    

  }

  async sair(){

    this.saving = true;

    let ob = {      
      username: this.userName,
      password: this.oldPassword,
      oldPassword: this.oldPassword,
      newPassword: this.password.value,
      sessionMFA: this.sessionMFA,
      forcePassword: this.forcePassword 
    }

    let timeToExpire = 30;

    if ( this.us != null && this.us.user != null && ObjectUtil.isNotEmpty(this.us.user.passexptimeout) ){
        timeToExpire = this.us.user.passexptimeout;
    }
    
    let expiration = DateUtils.addDays(new Date(), timeToExpire);
    let expirationStr  = this.datepipe.transform(expiration, 'yyyy-MM-dd HH:mm:ss.SSS'); 

    ob['expiration'] = expirationStr;

    if(this.needMFA){
      await this.us.forgotPassword(this.userName,  this.password.value, this.mfaCode.value, null, null, "B", this.preferEmail, expirationStr).then(m=>{        
        this.snackBar.showSuccess("Senha alterada com sucesso.");
        this.dialogRef.close(true);  
      }, r=>{
        this.saving = false;
        this.snackBar.showError(r);
      }).catch(e=>{
        this.saving = false;
        this.snackBar.showError(e.errorMessage);
      });
    }else{ //Analisar
      await this.us.changePassword(ob).then(m=>{        
        this.snackBar.showSuccess("Senha alterada com sucesso.");
        this.saving = false;
        this.dialogRef.close(m);
      }, r=>{
        this.saving = false;
        this.snackBar.showError(r);
      }).catch(e=>{        
        this.saving = false;
        this.snackBar.showError(e.errorMessage);
      });
    }

    
  }

  

  get confirmacao() {
    return this.senhaGroup.get('confirmacao');
  }

  
  get password() {
    return this.senhaGroup.get('password');
  }

  get mfaCode() {
    return this.senhaGroup.get('mfaCode');
  }


  ngOnDestroy(){
    if ( this.sub !=null){this.sub.unsubscribe();}
 
  }

}
